export default __webpack_public_path__ + "static/media/menu-account-info.204d0509.svg";